module.exports = __webpack_public_path__ + "img/VRP_logo_Horizontal.bf2a6a40.jpg";